import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'isoWeek',
    standalone: false
})
export class IsoWeekPipe implements PipeTransform {

  transform(value: any): string | number {
    if (!value) return '';
    
    const date = new Date(value);
    if (isNaN(date.getTime())) return '';

    const target = new Date(date.valueOf());
    const dayNr = (date.getDay() + 6) % 7;
    target.setDate(target.getDate() - dayNr + 3);
    const firstThursday = new Date(target.getFullYear(), 0, 4);
    const firstDayNr = (firstThursday.getDay() + 6) % 7;
    firstThursday.setDate(firstThursday.getDate() - firstDayNr + 3);

    const weekNumber = 1 + Math.round(
      (target.getTime() - firstThursday.getTime()) /
      (7 * 24 * 60 * 60 * 1000)
    );

    return weekNumber;
  }
}
